export default "__VITE_ASSET__12225552__"